"use client";

import { IListStores } from "@/utils/redux/storeLocator";
import { Columns, Text } from "@dxp-feed/ui";
import Link from "@/components/Link";
import {
  handleRedirectOnMap,
  formatPhoneNumber,
} from "@/helpers/storeLocatorHelper";
interface IAddressContactDetailsProps {
  store: IListStores | null;
}
const AddressContactDetails: React.FC<IAddressContactDetailsProps> = ({
  store,
}) => {
  return (
    <>
      <Columns className="col-3 6xl:w-[278px] lgs:w-3/12 6xl:!px-0 md:w-5/12 w-full pb-6 lgs:order-2 order-1">
        <Text as="h2" className="font-sans lgs:text-2xl text-xl font-extrabold">
          Address
        </Text>
        <Text as="p" className="!text-body md:pt-4 md:pb-6 pb-4 pt-2">
          {store?.address
            ? [
                store.address.address1,
                store.address.address2,
                store.address.intersection,
                store.address.city,
                store.address.province,
                store.address.postalCode,
              ]
                .filter((value) => value && value.trim())
                .join(" ") || "N/A"
            : "N/A"}{" "}
        </Text>
        <Link
          className="text-brandSecondary !text-body font-bold underline"
          href="#"
          onClick={() => {
            handleRedirectOnMap(
              store?._geoloc?.lat,
              store?._geoloc?.lng,
              store?.address,
              store?.locationName,
            );
          }}
        >
          Get Directions
        </Link>
      </Columns>
      <Columns className="col-2 6xl:w-[192px] lgs:w-2/12 6xl:!px-0 md:w-4/12 w-full lgs:order-3 order-2">
        <Text as="h2" className="font-sans lgs:text-2xl text-xl font-extrabold">
          Contact
        </Text>
        <Text as="p" className="!text-body md:py-4 py-2">
          {store?.phoneDetails?.phone && (
            <a href={`tel:+${store.phoneDetails.phone}`}>
              Phone: {formatPhoneNumber(store.phoneDetails.phone)}
            </a>
          )}
        </Text>
        <Text as="p" className="!text-body pb-6">
          {store?.phoneDetails?.fax && `Fax: +${store.phoneDetails.fax}`}
        </Text>
        {(store?.management?.storeOwner || store?.management?.storeManager) && (
          <>
            <Text
              as="h2"
              className="font-sans lgs:block hidden text-2xl font-extrabold"
            >
              {store?.management?.authorityType
                ? store.management.authorityType.charAt(0).toUpperCase() +
                  store.management.authorityType.slice(1)
                : "Manager"}
            </Text>
            <Text className="text-body hidden relative pt-4 lgs:flex gap-[9px] items-center">
              <Text
                as="span"
                className="icon-user-profile text-2xl text-brandPrimary contents"
              />
              {store?.management?.storeOwner || store?.management?.storeManager}
            </Text>
          </>
        )}
      </Columns>
      <Columns className="col-3 md:w-3/12 w-full lgs:hidden lgs:order-4 order-3">
        {(store?.management?.storeOwner || store?.management?.storeManager) && (
          <>
            <Text
              as="h2"
              className="font-sans capitalize lgs:text-2xl text-xl font-extrabold"
            >
              {store?.management?.authorityType
                ? store.management.authorityType.charAt(0).toUpperCase() +
                  store.management.authorityType.slice(1)
                : "Manager"}
            </Text>
            <Text className="text-body relative md:pt-4 pt-2 flex gap-[9px] items-center">
              <Text
                as="span"
                className="icon-user-profile text-2xl text-brandPrimary contents"
              />
              {store?.management?.storeOwner || store?.management?.storeManager}
            </Text>
          </>
        )}
      </Columns>
    </>
  );
};

export default AddressContactDetails;
